import { Injectable, signal } from "@angular/core";
import { IPagination } from "app/core/http";

@Injectable({
    providedIn: 'root'
})
export class PaginationService {
    private readonly _pagination = signal<IPagination>({
        totalCount: 0,
        pageSize: 10,
        currentPage: 1,
        totalPages: 1
    });

    get pagination() {
        return this._pagination.asReadonly();
    }

    reset() {
        this._pagination.set({
            totalCount: 0,
            pageSize: 10,
            currentPage: 1,
            totalPages: 1
        });
    }

    setPagination(pagination: IPagination) {
        this._pagination.set({
            ...pagination,
            totalCount: pagination.totalCount || 0,
            totalPages: Math.max(1, pagination.totalPages || 1),
            currentPage: pagination.currentPage || 1
        });
    }
}
